/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Components } from './components';
import { ReleaseStateEnum } from './releaseStateEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface ReleaseData { 
    /**
     * Version Sting
     */
    version: string;
    release_type?: ReleaseTypeEnum;
    service_type: ServiceTypeEnum;
    persona?: VcdsPersonaEnum;
    /**
     * Cloud provider of release
     */
    cloud_provider?: string;
    state: ReleaseStateEnum;
    /**
     * Upgrade Allowed from these releases
     */
    upgrade_from?: Array<string>;
    /**
     * Upgrade Allowed to these releases
     */
    upgrade_to?: Array<string>;
    components: Components;
    /**
     * Email Id of the user loading  the release
     */
    created_by?: string;
    /**
     * Time at which release was created/added to matrix
     */
    created_date_time?: Date;
    /**
     * Email Id of the user loading  the release
     */
    modified_by?: string;
    /**
     * Time at which release data was last updated
     */
    modified_date_time?: Date;
    /**
     * Comments/Notes regarding these release
     */
    notes?: string;
    /**
     * Map of release capability name to value
     */
    'release-capabilities'?: { [key: string]: string; };
    /**
     * If true (default false), skip some validation to load this release in SaaSInfra.
     */
    skip_validation?: boolean;
    /**
     * List of org ids having access to release
     */
    access_list?: Array<string>;
}
export namespace ReleaseData {
}


